<div class="h-screen w-full overflow-hidden">
  <app-header></app-header>
  <app-toolbar></app-toolbar>
  <div class="flex flex-row align-middle ml-7 mt-2 gap-1 cursor-pointer" (click)="goBack()">
    <img class=" w-fit box-border h-4" src="assets/icons/Arrow 1.png" alt="">
    <p class="text-[#5B6563] font-medium text-xs">Volver</p>
  </div>
  <div class="h-12 grid grid-cols-12 px-7" *ngIf="bookingDetail !== undefined">
    <div class="col-span-6 border-b-2 border-blue-900 mt-2">
      <div class="flex flex-row mb-2 gap-1 ">
        <p class="text-[#27368A] font-extrabold text-xl ">RESERVA:</p>
        <p class="text-red-600 font-bold text-xl">#{{ bookingDetail.reference }}</p>
      </div>
    </div>
    <div class="col-span-6 border-b-2 border-blue-900 ">
      <div class="flex flex-row mb-2 float-right">
        <p
          class="text-center text-white font-semibold text-lg px-2 py-1 mt-1 w-48 rounded-md {{bookingDetail.status.color}} {{bookingDetail.status.text_color}}">
          {{ bookingDetail.status.status}}</p>
      </div>
    </div>
  </div>
  <div class="grid grid-cols-12 h-full px-7" *ngIf="bookingDetail !== undefined">
    <div class="col-span-3 border-r-2 border-slate-500 p-3">
      <p class="font-extrabold text-xl ">Actividades:</p>
      <hr class="mt-2 border-2">
      <table *ngIf="bookingDetail.services.length > 0"
        class="w-full border-collapse border border-gray-200 text-left text-xs mt-2">
        <thead class="bg-gray-200">
          <tr>
            <th class="border border-gray-300 px-4 py-1">Actividad</th>
            <th class="border border-gray-300 px-4 py-1">Fecha y hora</th>
            <th class="border border-gray-300 px-4 py-1">Subtotal</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="bookingDetail.services.length > 0; else noActivitiesMessage">
            <tr *ngFor="let bookedService of bookingDetail.services; let i = index;">
              <td class="border border-gray-300 px-4 py-1">
                {{ getService(bookedService.service_profile_id) }}<br>
                <b>({{ bookedService.units}}x)</b> {{ bookedService.service_profile?.name}}
              </td>
              <td class="border border-gray-300 px-4 py-1">
                {{ bookedService.date}} {{ bookedService.hour }}
              </td>
              <td class="border border-gray-300 px-4 py-1 text-base text-right font-bold text-red-700">
                {{ bookedService.unit_price * bookedService.units | currency:'EUR' }}
              </td>
            </tr>
          </ng-container>
          <ng-template #noActivitiesMessage class="border-b-2 ">
            <p class="font-extralight text-[#8A8A8A]">
              Aún no hay actividades
            </p>
          </ng-template>
        </tbody>
      </table>
    </div>
    <div class="col-span-6">
      <div class="xl:my-4 flex justify-center">
        <div class="flex flex-row ">
          <div class="focus-visible:ring" id="calculator-container">
            <div class=" bg-[#D9D9D9] border border-black  grid justify-center items-end pb-3 mb-2" id="display">
              <p class=" text-blue-800 font-extrabold text-3xl grid justify-center align-bottom sm:text-2xl"
                id="display-text">{{ display }} </p>
            </div>
            <div #calculator (keydown)="keyboardCalculator($event)" autoFocus
              class="grid grid-cols-4 gap-2 bg-[#D9D9D9] p-2 " id="calculator">
              <button (click)="reset()" class="bg-[#736f6f] text-white text-center text-2xl font-semibold"
                id="button-reset">C</button>
              <button (click)="backspace()" class="bg-[#736f6f] text-white text-center text-2xl font-semibold "
                id="button">⌫</button>
              <button (click)="oper('%')" class="bg-[#E79418] text-white text-center text-2xl font-semibold "
                id="button">%</button>
              <button (click)="oper('/')" class="bg-[#E79418] text-white text-center text-4xl font-semibold "
                id="button">/</button>
              <button (click)="numClick('1')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">1</button>
              <button (click)="numClick('2')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">2</button>
              <button (click)="numClick('3')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">3</button>
              <button (click)="oper('*')" class="bg-[#E79418] text-white text-center text-4xl font-semibold "
                id="button">*</button>
              <button (click)="numClick('4')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">4</button>
              <button (click)="numClick('5')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">5</button>
              <button (click)="numClick('6')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">6</button>
              <button (click)="oper('-')" class="bg-[#E79418] text-white text-center text-4xl font-semibold "
                id="button">-</button>
              <button (click)="numClick('7')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">7</button>
              <button (click)="numClick('8')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">8</button>
              <button (click)="numClick('9')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">9</button>
              <button (click)="oper('+')" class="bg-[#E79418] text-white text-center text-4xl font-semibold "
                id="button">+</button>
              <button (click)="changeSign()" class="bg-[#736f6f] text-white text-center text-2xl font-semibold "
                id="button">+/-</button>
              <button (click)="numClick('0')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">0</button>
              <button (click)="numClick('.')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">,</button>
              <button (click)="calculate()" class="bg-[#736f6f] text-white text-center text-4xl font-semibold "
                id="button">=</button>
            </div>
          </div>
          <div class="grid grid-rows gap-2" id="buttons-container">
            <button
              class="{{ selectedPaymentType === 'EFECTIVO' ? 'border-slate-100 border-2 bg-[#E79418] text-white text-center text-xl font-semibold  p-5' : ' bg-blue-500 text-white text-center text-xl font-semibold  p-5' }}"
              id="button-pay" (click)="paymentType('EFECTIVO')">EFECTIVO</button>
            <button
              class="{{ selectedPaymentType === 'TARJETA' ? 'border-slate-100 border-2 bg-[#E79418] text-white text-center text-xl font-semibold  p-5' : ' bg-blue-600 text-white text-center text-xl font-semibold  p-5' }}"
              id="button-pay" (click)="paymentType('TARJETA')">TARJETA</button>
            <button
              class="{{ selectedPaymentType === 'BIZUM' ? 'border-slate-100 border-2 bg-[#E79418] text-white text-center text-xl font-semibold  p-5' : ' bg-blue-600 text-white text-center text-xl font-semibold  p-5' }}"
              id="button-pay" (click)="paymentType('BIZUM')">BIZUM</button>
            <button
              class="{{ selectedPaymentType === 'TRANSFERENCIA' ? 'border-slate-100 border-2 bg-[#E79418] text-white text-center text-xl font-semibold  p-5' : ' bg-black text-white text-center text-xl font-semibold  p-5' }}"
              id="button-pay" (click)="paymentType('TRANSFERENCIA')">TRANSFERENCIA</button>
          </div>
        </div>

        <div class="grid h-full gap-4" id="change">
          <div>
            <p class="grid justify-start text-[#27368A] font-bold">IMPORTE QUE RECIBES</p>
            <ng-container>
              <div>
                <input (input)="changeToReturn()" [(ngModel)]="putMoney"  #putMoneyInput  type="number" placeholder="Introduce el importe"
                  class="h-16 w-96 sm:w-72  bg-[#D9D9D9] border border-black items-end p-2 text-white font-medium text-2xl grid justify-center align-bottom sm:h-10">
              </div>
            </ng-container>
          </div>
          <div>
            <p class="grid justify-start text-[#27368A] font-bold">CAMBIO A DEVOLVER:</p>
            <p class="text-red-600 font-bold lg:text-6xl sm:text-4xl">{{ change + '€'}}</p>
          </div>
          <div class="grid items-end align-bottom">
            <button
              class="bg-[#42BC18] justify-center items-center text-white text-xl font-bold h-48 w-96 sm:w-72 sm:h-36 mt-24 disabled:cursor-not-allowed disabled:opacity-40"
              (click)="confirmBooking()"
              [disabled]="display === '' || !selectedPaymentType ">CONFIRMAR</button>
          </div>
        </div>
      </div>
      <div class=" flex place-content-end align-bottom items-end flex-col my-4 mr-12">
        <p class="grid justify-start text-red-900 font-bold">PENDIENTE DE COBRAR:</p>
        <p class="text-red-600 font-bold lg:text-6xl sm:text-4xl">{{ this.bookingDetail.pending_amount + '€' }}</p>
      </div>
    </div>

    <div class="col-span-3 border-l-2 border-slate-500 p-3 flex flex-col">
      <p class="font-extrabold text-xl ">Ticket a imprimir:</p>
      <hr class="mt-2 border-2">
      <div class="">
        <div *ngIf="!confirmedEntry"
        class="flex justify-center items-center w-full bg-slate-200 border border-dashed border-slate-500 rounded-xl hover:cursor-pointer p-6 mb-4 mt-2">
        <h1 class="text-center text-xl text-slate-500">
          No hay cobros registrados<br>
          <small>Introduzca un importe</small>
        </h1>
      </div>
      <table *ngIf="confirmedEntry" class="w-full border-collapse border border-gray-200 text-left text-xs mt-2">
        <thead class="bg-gray-200">
          <tr>
            <th class="border border-gray-300 px-4 py-1">Método pago</th>
            <th class="border border-gray-300 px-4 py-1">Importe</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let entry of ticketData">
            <td class="border border-gray-300 px-4 py-1">
              {{ entry.payment_method}}
            </td>
            <td class="border border-gray-300 px-4 py-1 text-base text-right font-bold text-red-700">
              {{ entry.amount | currency:'EUR'}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
      <div class="grid justify-center items-end align-bottom fixed bottom-4 right-4 col-span-3">
        <button
          class="bg-[#27368A] justify-center items-center text-white text-xl font-bold w-[450px] h-32 sm:h-24  disabled:cursor-not-allowed disabled:opacity-40"
          (click)="printTicket()" [disabled]="!confirmedEntry">FINALIZAR</button>
      </div>
    </div>
  </div>
</div>
